import {Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React, {useCallback} from 'react'
import type {FeedbackReason} from 'src/api/types'

import {classes} from './TagReason.styles'

type Props = {
  data: FeedbackReason
  selected: boolean
  onClick: Function
}

const TagReason: React.FC<Props> = ({data, onClick, selected = false}) => {
  const {reason_id: id, title} = data
  const handleReasonClick = useCallback(() => onClick(id), [id, onClick])

  return (
    <Typography
      Component="div"
      className={clsx(classes.root, selected && classes.selected)}
      data-e2e={id}
      onClick={handleReasonClick}
      variant="body2"
    >
      {title}
    </Typography>
  )
}

export default TagReason
